// extracted by mini-css-extract-plugin
export default {"profile":"HrProfileModal_profile__+qwJj"};